import { render, staticRenderFns } from "./dossier-detail-component-button.vue?vue&type=template&id=9f144a88&scoped=true"
import script from "./dossier-detail-component-button.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f144a88",
  null
  
)

export default component.exports